import React from "react";
import { defaultSettings } from "./defaults/settings";

import Component from "./Component";
import Form from "./Form/VideoForm";

// Named under pizzaexpresslive/ rather than peracto/content/video: peracto-content
// always registers its own Video block and ignores custom blocks in the peracto/
// namespace that it doesn't explicitly support overriding.
const createPlugin = (settings) => {
  const mergedSettings = { ...defaultSettings, ...settings };

  return {
    Component: (props) => <Component {...props} {...mergedSettings} />,
    FormComponent: (props) => <Form {...props} />,

    name: "pizzaexpresslive/content/video",
    version: "1.0.0",
    text: mergedSettings.translations.pluginName,
    description: mergedSettings.translations.pluginDescription,
    IconComponent: mergedSettings.IconComponent,

    createInitialState: () => ({
      url: "",
      poster: "",
      autoPlay: false,
      loop: false,
      controls: false,
      showControlsOnHover: false,
      muted: false,
      playsInline: false,
    }),
  };
};

export default createPlugin;
